import { mergeClassNames } from "../utils/style";
import { IconProps } from "./types";

type Props = IconProps & {
  direction?: "left" | "right";
};

export default function IconChevron({ className, direction }: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 6 10"
      className={mergeClassNames(
        className ?? "h-2",
        direction === "right" && "rotate-180"
      )}
    >
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M5 1 1 5l4 4"
      />
    </svg>
  );
}
